export const DIGIT_EVALUATION = [
  { code: 2, description: '2' },
  { code: 3, description: '3' },
  { code: 4, description: '4' },
  { code: 5, description: '5' },
];
